module.exports = __webpack_public_path__ + "static/media/LandingPageVideoPortrait.c83bd8b8.mp4";